export default __webpack_public_path__ + "static/media/romeniaIcon.b931ef68.svg";